export interface Template {
  id: string;
  title: string;
  category: string;
  image: string;
  downloads: string;
  isNew?: boolean;
  isHot?: boolean;
}

export const featuredTemplates: Template[] = [
  {
    id: "tpl-001",
    title: "小红书爆款封面模板",
    category: "社交媒体",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20social%20media%20cover%20template%20design%20with%20pastel%20pink%20and%20cream%20colors%2C%20minimal%20elegant%20layout%20with%20text%20placeholders%2C%20clean%20white%20background%20with%20soft%20shadows%2C%20editorial%20aesthetic&width=600&height=420&seq=template-redbook-01&orientation=landscape",
    downloads: "12.8万",
    isHot: true,
  },
  {
    id: "tpl-002",
    title: "品牌VI视觉系统",
    category: "品牌设计",
    image: "https://readdy.ai/api/search-image?query=Professional%20brand%20identity%20design%20template%20set%20with%20business%20cards%20and%20stationery%20on%20clean%20minimal%20surface%2C%20warm%20natural%20light%2C%20elegant%20corporate%20aesthetic%2C%20soft%20cream%20background&width=600&height=420&seq=template-brand-02&orientation=landscape",
    downloads: "9.6万",
  },
  {
    id: "tpl-003",
    title: "电商促销海报模板",
    category: "电商设计",
    image: "https://readdy.ai/api/search-image?query=Modern%20ecommerce%20promotional%20banner%20design%20with%20bold%20typography%20and%20product%20showcase%2C%20clean%20minimal%20layout%20with%20warm%20orange%20accents%2C%20professional%20marketing%20aesthetic&width=600&height=420&seq=template-ecommerce-03&orientation=landscape",
    downloads: "15.3万",
    isNew: true,
  },
  {
    id: "tpl-004",
    title: "公众号头图模板合集",
    category: "新媒体",
    image: "https://readdy.ai/api/search-image?query=Collection%20of%20elegant%20WeChat%20article%20header%20image%20templates%20with%20minimal%20Chinese%20typography%2C%20clean%20white%20background%20with%20subtle%20artistic%20elements%2C%20editorial%20design%20style&width=600&height=420&seq=template-wechat-04&orientation=landscape",
    downloads: "8.2万",
    isHot: true,
  },
  {
    id: "tpl-005",
    title: "招聘海报创意模板",
    category: "企业办公",
    image: "https://readdy.ai/api/search-image?query=Creative%20recruitment%20poster%20design%20with%20modern%20geometric%20elements%20and%20bold%20typography%2C%20clean%20white%20background%20with%20colorful%20accents%2C%20professional%20HR%20marketing%20aesthetic&width=600&height=420&seq=template-job-05&orientation=landscape",
    downloads: "6.7万",
  },
  {
    id: "tpl-006",
    title: "美食菜单设计套装",
    category: "餐饮美食",
    image: "https://readdy.ai/api/search-image?query=Elegant%20food%20menu%20design%20template%20with%20minimal%20clean%20layout%20and%20warm%20earth%20tone%20colors%2C%20soft%20cream%20background%2C%20sophisticated%20restaurant%20aesthetic&width=600&height=420&seq=template-menu-06&orientation=landscape",
    downloads: "5.4万",
    isNew: true,
  },
  {
    id: "tpl-007",
    title: "活动邀请函模板",
    category: "活动策划",
    image: "https://readdy.ai/api/search-image?query=Elegant%20event%20invitation%20card%20design%20with%20gold%20foil%20accents%20and%20minimal%20typography%2C%20clean%20cream%20background%2C%20luxurious%20simple%20aesthetic%2C%20flat%20lay%20photography&width=600&height=420&seq=template-invitation-07&orientation=landscape",
    downloads: "7.9万",
  },
  {
    id: "tpl-008",
    title: "个人简历创意模板",
    category: "职场求职",
    image: "https://readdy.ai/api/search-image?query=Modern%20creative%20resume%20CV%20template%20design%20with%20clean%20minimal%20layout%2C%20soft%20neutral%20colors%20on%20white%20background%2C%20professional%20elegant%20aesthetic&width=600&height=420&seq=template-resume-08&orientation=landscape",
    downloads: "11.2万",
  },
];